import btnImg from '@assets/web-v3-images/btn-buy.png';
import imgTurns from '@assets/web-v3-images/turns-img.png';
import { Text } from '@radix-ui/themes';
import Buttons from '../Buttons';
import PopupFrame from '.';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function UpdateNameProfile({ open, onOpenChange, valueName, onChangeUpdateName }) {
	const [name, setName] = useState("");
	const { t } = useTranslation();
	useEffect(() => {
		if (open) {
			setName(valueName);
		}
	}, [open, valueName]);


	return (
		<PopupFrame
			open={open}
			onOpenChange={onOpenChange}
			title={t("update_profile_name")}
		>
			<div className='mt-7'>
				<div className="w-full flex flex-col gap-2">
					<label className="text-[#6E4A21] text-[17px] sm:text-[20px] font-semibold">
						{t("your_profile_name")}
					</label>

					<input
						value={name}
						onChange={(e) => setName(e.target.value.slice(0, 20))}
						maxLength={20}
						type="text"
						defaultValue="Cristela Estilista"
						className="
								w-full
								h-11 sm:h-12 md:h-14
								rounded-xl md:rounded-2xl
								border border-[#F3A45B]
								bg-white/70
								px-4
								text-[#6E4A21]
								text-base sm:text-lg
								font-semibold
								outline-none
								focus:border-[#E86C1E]
								transition
							"
					/>
				</div>
			</div>

			<div className='px-[20%] pt-[10%]'>
				<Buttons
					handleClick={() => {
						onChangeUpdateName(name);
						onOpenChange(false);
					}}
					textBtn={t("modal.modal_login.confirm")} />
			</div>
		</PopupFrame >
	)
}
